import Vue from 'vue'

export async function getCurrentIP() {
    return Vue.axios
        .get(process.env.VUE_APP_CLIENT_IP_API)
        .then((response) => response)
}
